import { Box, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { colors } from "../theme/colors";
import InspiraLogo from "../assets/svg/incon_inspira.svg";
import { useLocation, useNavigate } from "react-router-dom";

import ResultBackground from "../assets/svg/banner_pagado.svg";

export default function Header() {
  const [infoPage, setinfoPage] = useState();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    pathname === "/info" ? setinfoPage(true) : setinfoPage(false);
  }, [pathname]);

  return (
    <Box
      sx={{
        height: {
          xs:
            pathname.split("/")[1] === "details" ||
            pathname.split("/")[1] === "pay"
              ? "235px"
              : pathname.split("/")[1] === "result"
                ? "177px"
                : "100px",
          md:
            pathname.split("/")[1] === "details" ||
            pathname.split("/")[1] === "pay"
              ? "235px"
              : pathname.split("/")[1] === "result"
                ? "642px"
                : "100px",
        },
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor:
          pathname.split("/")[1] === "result" ? "transparent" : colors.headerbk,
        backgroundImage:
          pathname.split("/")[1] === "result"
            ? `url(${ResultBackground})`
            : "none",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {pathname.split("/")[1] !== "result" && (
        <Grid container spacing={2} justifyContent="center" alignItems="center">
          <Grid item sm={1}></Grid>
          <Grid item sm={3}></Grid>
          <Grid
            item
            sm={4}
            style={{ textAlign: "center", marginTop: "1rem" }}
            onClick={() => navigate("../../")}
            sx={{ "&:hover": { cursor: "pointer" } }}
          >
            <img
              src={InspiraLogo}
              alt="Inspira-Airlines"
              style={{ maxWidth: "100%" }}
            />
          </Grid>
          <Grid item xs={0} sm={4} md={2}></Grid>
          <Grid
            item
            xs={6}
            sm={3}
            md={2}
            sx={{ paddingTop: "0 !important", textAlign: "center" }}
          ></Grid>
        </Grid>
      )}
    </Box>
  );
}
